<template>
  <section class="all_emp card_style" style="height: 100dvh">
    <div class="d-flex align-items-center gap-3 mb-2">
      <AddFavDailog v-tooltip.left="$t('add_to_favourite')" />
      <h4>{{ $t("Header") }}</h4>
    </div>
    <div class="main_header_style mb-3">
      <div class="my-1 w-100 d-flex align-items-center justify-content-between">
        <input
          type="text"
          v-model="couponText"
          @keyup="fetchheader()"
          class="form-control w-50"
          :placeholder="$t('search...')"
        />
        <router-link to="/headersection" class="PrimaryButton btn"
          ><i class="fa-solid fa-plus"></i> {{ $t("New Header") }}
        </router-link>
      </div>
    </div>

    <div class="row">
      <table class="table" id="couponTable">
        <thead>
          <tr>
            <th>ID</th>
            <th>{{ $t("Title") }}</th>
            <th>{{ $t("description") }}</th>
            <th>{{ $t("sub_title") }}</th>
            <th>{{ $t("type") }}</th>
          </tr>
        </thead>

        <tbody class="text-center">
          <tr v-for="(header, index) in headers" :key="index">
            <!-- {{ console.log(header , "header") }} -->
            <td>{{ header.title }}</td>
            <td>{{ header.description }}</td>
            <td>{{ header.sub_title }}</td>
            <td>{{ header.type }}</td>

            <button
              class="btn btn-danger mx-1 w-auto"
              @click="deleteCoupon(header.id, index)"
            >
              <i class="fa-solid fa-trash mx-1" style="font-size: 1rem"></i>
            </button>
            <!-- <td v-for="coupon in 7" :key="coupon">
              <Skeleton height="2rem" width="90%" class="mb-2"></Skeleton>
            </td> -->
          </tr>
        </tbody>

        <!-- <tbody v-else>
          <tr v-for="(coupon, index) in coupons.data" :key="index">
            <td>{{ coupon.id }}</td>
            <td>{{ coupon.title }}</td>
            <td>{{ coupon.description }}</td>
            <td>
              {{ coupon.expired_date }}
            </td>
            <td>{{ coupon.expired_time }}</td>
            <td>
              <span
                class="coupon_status"
                :class="{
                  disactive: coupon.status == 'Disactive',
                  active: coupon.status == 'Active',
                }"
                >{{ coupon.status }}</span
              >
            </td>
            <td>
              <button
                v-if="coupon.expired_date > formattedDate"
                class="btn btn-warning mx-1 w-auto"
                @click="changeStatus(coupon.id, index)"
              >
                <i class="fa-solid fa-triangle-exclamation text-white"></i>
              </button>

              <button class="btn btn-success mx-1 w-auto">
                <router-link :to="`/coupons/edit/${coupon.id}`">
                  <i class="fa-solid fa-pen-to-square text-white"></i>
                </router-link>
              </button>

              <button
                class="btn btn-danger mx-1 w-auto"
                @click="deleteCoupon(coupon.id, index)"
              >
                <i class="fa-solid fa-trash mx-1" style="font-size: 1rem"></i>
              </button>
            </td>
          </tr>
        </tbody> -->
      </table>
    </div>

    <!-- <div class="row">
      <pagination
        :data="coupons"
        class="mx-auto d-flex align-items-center justify-content-center pagination"
        @pagination-change-page="fetchcoupons"
      >
        <template v-slot:prev-nav>&lt;</template>
        <template v-slot:next-nav>&gt;</template>
      </pagination>
    </div> -->
  </section>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from "axios";
// import pagination from "laravel-vue-pagination";
import Swal from "sweetalert2";
import AddFavDailog from "@/components/layout/addFavDailog.vue";
// import Skeleton from "primevue/skeleton";
// import $ from "jquery";
export default {
  name: "coupons-Show",
  components: {
    // pagination,
    AddFavDailog,
    // Skeleton,
  },
  data() {
    return {
      headers: [],
      formattedDate: "",
      couponText: "",
      loading: true,
    };
  },
  methods: {
    formatCurrentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
      const day = currentDate.getDate().toString().padStart(2, "0");
      this.formattedDate = `${year}-${month}-${day}`;
    },
    fetchheader() {
      axios
        .post(`/fetch_headers`, {
          word: this.couponText,
        })
        .then(({ data }) => {
          this.headers = data.data;
          this.loading = false;
        });
    },
    //delete visa
    deleteCoupon(id, index) {
      axios.post(`/delete_header`, { header_id: id }).then(({ data }) => {
        this.fetchheader();
        return data;
      });
    },
    // changeStatus(id, index) {
    //   let status_data = {
    //     coupon_id: id,
    //     status:
    //       this.coupons.data[index].status == "Active"
    //         ? 1
    //         : this.coupons.data[index].status == "Disactive"
    //         ? 0
    //         : null,
    //   };

    //   axios
    //     .post(`/change_coupon_status`, status_data)
    //     .then(({ data }) => {
    //       // console.log(data);
    //       this.fetchcoupons();
    //       Swal.fire({
    //         title: "",
    //         text: data.message,
    //         icon: "success",
    //       });
    //     })
    //     .catch((error) => {
    //       Swal.fire({
    //         title: "",
    //         text: error.response.data.message,
    //         icon: "error",
    //       });
    //     });
    // },
  },
  mounted() {
    this.fetchheader();
    this.formatCurrentDate();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
// @import "./_visa.scss";
</style>
